import React from 'react';
import { useStopLight } from './useStopLight';

interface StopLightWithMessageProps {
	checklistColor: string;
	messageStyles?: React.CSSProperties;
}

const StopLightWithMessage: React.FC<StopLightWithMessageProps> = ({ checklistColor, messageStyles }) => {
	const { icon, message } = useStopLight(checklistColor);
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				gap: '0.5rem',
			}}
		>
			{icon} <span style={messageStyles}>{message}</span>
		</div>
	);
};

export default StopLightWithMessage;
